"use strict";

var KTChartsWidget38 = (function () {

  var initChart = function (chartSelector) {
    var elementList = document.querySelectorAll(chartSelector);

    if (!elementList) {
      return;
    }

    elementList.forEach((element, index) => {
      var height = parseInt(KTUtil.css(element, "height"));


    var options = {
      series: [
        {
          name: aylikUretimArray[index]["title"],
          data: aylikUretimArray[index]["values"],
        },
      ],
      chart: {
        height: height || 400,
        type: "area",
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        labels: {
          rotate: -45
        },
        type: "string",
        categories: [
          "May 23",
          "Haz 23",
          "Tem 23",
          "Ağu 23",
          "Eyl 23",
          "Eki 23",
          "Kas 23",
          "Ara 23",
          "Oca 24",
          "Şub 24",
          "Mar 24",
          "Nis 24",
        ],
      },

      tooltip: {
        x: {
          format: "dd/MM/yyYY HH:mm",
        },
      },
      colors: [aylikUretimArrayColors[index]],
    };

    var chart = new ApexCharts(element, options);
    chart.render();
    })


  };

  // Public methods
  return {
    init: function () {
      initChart(".irregular_widget_selector");
    },
  };
})();

// Webpack support
if (typeof module !== "undefined") {
  module.exports = KTChartsWidget38;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTChartsWidget38.init();
});
